"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_MAPPING = {
    prefix: 'auth',
    signIn: {
        path: '/signIn',
    },
    forgotPassword: {
        path: '/forgotPassword'
    },
    getChainMangerToken: {
        path: '/getChainManagerToken',
        parameter: '/:chainId'
    },
    checkPccLogin: {
        path: '/checkPccLogin'
    },
    logout: {
        path: '/logout'
    },
    refreshToken: {
        path: '/refreshToken'
    }
};
